<template>
    <div>
		<form @submit.prevent="validateBeforeSubmit">

            <div class="row">
                <div class="col-lg-10 col-xl-8">
                    <BasicInput
                        label="What's your email?"
                        id="email"
                        name="email"
                        type="email"
                        v-model="email"
                        :exval="validationAttempt"
                        v-validate="'required|email'"
                        errormsg="This is a required field"
                        :error="errors.first('email')" />
                </div>
            </div>
            
            <div class="row">
                <div class="col-lg-10 col-xl-8">
                    <CleaveInput
                        label="Last 4 digits of your SSN"
                        id="ssnLast4"
                        name="ssnLast4"
                        type="tel"
                        maxlength="4"
                        autocomplete="off"
                        v-model="ssnLast4"
                        v-validate="{ required: true, regex: /^([0-9]{4})$/ }"
                 
                        :exval="validationAttempt"
                        :cleaveoptions="masks.ssnLast4"

                        extracss="dont-mark"
                 
                        errormsg="This is a required field"
                        :error="errors.first('ssnLast4')"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-lg-10 col-xl-8">
                    <LoanSelect
                        label="How much do you want to borrow?"
                        id="loan_amount"
                        name="loan_amount"
                        type="hidden"
                        v-model="loan_amount"
                        v-validate="'required'"
                        errormsg="This is a required field"
                        :error="errors.first('loan_amount')" />
                </div>
            </div>

            <div class="light txt-grey p14 my-5" style="max-width: 470px;">By submitting your information, you agree to the terms of our <a href="/legal/privacy" target="_blank">Privacy Policy</a>, <a href="/legal/tos" target="_blank">Terms of Use</a> and <a href="/legal/disclaimer" target="_blank">Disclaimer</a>.</div>

            <div v-if="errorMessage" class="alert alert-danger">
                Unfortunately that number doesn't match the records in our system. Try again or <router-link to="/apply/1">Click Here to submit a new application</router-link>.
            </div>

			<div class="my-5 d-flex align-items-center">
                <button class="btn btn-cta btn-red uc" id="form-submit">{{ this.loading ? 'Sending...' : 'Continue' }}</button>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
            </div>
			
		</form>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from 'axios';
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
import LoanSelect from '@/components/form/LoanSelect.vue';

export default {
	name: 'LoginLeadForm',
	components: {
        BasicInput,
        CleaveInput,
		LoanSelect
	},
  props: {
    show: Boolean
	},
	methods: {
		...mapActions(['saveFormData', 'authoriseUser']),
		validateBeforeSubmit() {
			this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
							this.saveFormData({
								firstStep: true,
								'email' : this.email.toLowerCase(),
                                'loan_amount' : this.loan_amount,
                                'loan_amount_raw' : this.loan_amount_raw,
                                'loan_amount_range' : this.loan_amount_range
							});
							this.sendData();	
          		return;
				}
      		});
        },
        async sendData(){
            const endpoint = `${process.env.VUE_APP_LOCAL_API}verifyEmail?email=${this.email}&ssn_last4=${this.ssnLast4}`;
			try {
				this.loading = true;
				const response = await axios.get(endpoint);
				if(response.data.body){
                    this.authoriseUser({
                        clientKey: response.data.clientKey,
                        ...response.data.body
                    });
                    this.$router.push({ path: '/users/returning' });
				} else {
                    this.loading = false;
                    this.errorMessage = true;
                }
			} catch(err) {
				this.loading = false;
				console.log(err);
			}
        },
        getLoanAmountValue(){
            const amounts = this.loanAmounts.find(o => o.type === process.env.VUE_APP_SITE_TYPE);
            const loanAmount = amounts.amounts.find(obj => {
                return obj.label === this.loan_amount;
            });
            this.loan_amount_raw = loanAmount.value;
            this.loan_amount_range = loanAmount.range;
        }
    },
	data() {
		return {
            validationAttempt: false,
            errorMessage: false,
			masks: {
                ssnLast4: { numericOnly: true, blocks: [4] },
            },
			email: '',
			ssnLast4: '',
            loan_amount: '',
            loan_amount_raw: 0,
            loan_amount_range: '',
			loading: false,
		}
    },
    computed: mapGetters(["loanAmounts"]),
    watch: {
        loan_amount: 'getLoanAmountValue'
    },
    created(){
        const urlParams = new URLSearchParams(window.location.search);
        this.email = urlParams.get('email');
        let obj = this.loanAmounts.find(o => o.type === process.env.VUE_APP_SITE_TYPE);
        let obj2 = obj.amounts.find(o => o.value == urlParams.get('amount'));
        this.loan_amount = obj2.label;
    }
}
</script>